
import {createSlice} from '@reduxjs/toolkit'
import { fetchbenefits } from '../../action/master/benefitsAction'

interface benefitsState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: benefitsState = {
  data: null,
  status: 'idle',
  error: null,
}

const benefitsSlice = createSlice({
  name: 'benefits',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchbenefits.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchbenefits.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchbenefits.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default benefitsSlice.reducer
